import { Users, MonitorSmartphone } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AppHeader } from "@/components/AppHeader";
import { useAuth } from "@/context/AuthContext";
import { TeamPanel } from "@/components/settings/TeamPanel";
import { SessionsPanel } from "@/components/settings/SessionsPanel";

export default function Settings() {
  const { user } = useAuth();
  const owner = user?.role === "owner";
  return (
    <div className="min-h-screen bg-[#090D16] text-slate-100">
      <AppHeader><span className="font-mono text-xs uppercase tracking-wider text-slate-400" data-testid="settings-title">Settings</span></AppHeader>
      <main className="max-w-4xl px-4 sm:px-8 lg:px-12 py-10">
        <div className="mb-8 rise">
          <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight">Workspace settings</h1>
          <p className="text-sm text-slate-400 mt-2" data-testid="settings-role">
            Signed in as <span className="text-slate-200">{user?.email}</span> · {owner ? "Owner" : "Staff"}
          </p>
        </div>
        <Tabs defaultValue={owner ? "team" : "devices"}>
          <TabsList className="h-10 bg-[#0d1220] border border-slate-800 p-1 mb-6">
            {owner && <TabsTrigger value="team" data-testid="settings-tab-team" className="text-xs gap-1.5 data-[state=active]:bg-slate-800 data-[state=active]:text-cyan-300"><Users size={14} />Team</TabsTrigger>}
            <TabsTrigger value="devices" data-testid="settings-tab-devices" className="text-xs gap-1.5 data-[state=active]:bg-slate-800 data-[state=active]:text-cyan-300"><MonitorSmartphone size={14} />Devices</TabsTrigger>
          </TabsList>
          {owner && <TabsContent value="team" className="rise"><TeamPanel /></TabsContent>}
          <TabsContent value="devices" className="rise"><SessionsPanel /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
